import {
    IconCheck,
    IconSettings,
    IconShield,
    IconWarningTriangle,
} from "@noones/ui/icons/mono-no-pixel";
import { tw } from "@noones/ui/tw";
import { ComponentStatusEnum } from "@store/types";
import React, { ReactNode } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import cx from "classnames";

type StatusCardType = {
    name: string;
    status: ComponentStatusEnum;
};

type OperationObjectType = {
    title: ReactNode;
    icon: ReactNode;
    textColor: string;
};

export const StatusCard = ({ name, status }: StatusCardType) => {
    const operationNames: {
        [key: string]: OperationObjectType;
    } = {
        [ComponentStatusEnum.OPERATIONAL]: {
            title: <FormattedMessage {...messages.titleOnline} />,
            icon: <IconCheck width={20} height={20} className={tw.text_green} />,
            textColor: tw.text_green,
        },
        [ComponentStatusEnum.UNDER_MAINTENANCE]: {
            title: <FormattedMessage {...messages.titleMaintenance} />,
            icon: <IconSettings width={20} height={20} className={tw.text_dark_blue} />,
            textColor: tw.text_dark_blue,
        },
        [ComponentStatusEnum.DEGRADED_PERFORMANCE]: {
            title: <FormattedMessage {...messages.titleDegraded} />,
            icon: <IconSettings width={20} height={20} className={tw.text_orange} />,
            textColor: tw.text_orange,
        },
        [ComponentStatusEnum.PARTIAL_OUTAGE]: {
            title: <FormattedMessage {...messages.titlePartialOutage} />,
            icon: <IconWarningTriangle width={20} height={20} className={tw.text_orange} />,
            textColor: tw.text_orange,
        },
        [ComponentStatusEnum.MAJOR_OUTAGE]: {
            title: <FormattedMessage {...messages.titleMajorOutage} />,
            icon: <IconWarningTriangle width={20} height={20} className={tw.text_red} />,
            textColor: tw.text_red,
        },
        [ComponentStatusEnum.SECURITY_EVENT]: {
            title: <FormattedMessage {...messages.titleSecurityBreach} />,
            icon: <IconShield width={20} height={20} className={tw.text_red} />,
            textColor: tw.text_red,
        },
    };

    const { title, icon, textColor } = operationNames[status];

    return (
        <div className={tw.flex.items_center.justify_between}>
            <div className={tw.text_body_14.font_normal.text_grey_green}>{name}</div>

            <div className={tw.flex.items_center.gap_1}>
                {icon}
                <span className={cx(tw.text_body_14, textColor)}>{title}</span>
            </div>
        </div>
    );
};

const messages = defineMessages({
    titleOnline: {
        id: "Operation.online.title",
        defaultMessage: "Online",
        description: "Online title",
    },
    titleMaintenance: {
        id: "Operation.maintenance.title",
        defaultMessage: "Maintenance",
        description: "Maintenance title",
    },
    titleDegraded: {
        id: "Operation.degraded.title",
        defaultMessage: "Degraded performance",
        description: "Degraded performance title",
    },
    titlePartialOutage: {
        id: "Operation.partialOutage.title",
        defaultMessage: "Partial outage",
        description: "Partial outage title",
    },
    titleMajorOutage: {
        id: "Operation.majorOutage.title",
        defaultMessage: "Major outage",
        description: "Major outage title",
    },
    titleSecurityBreach: {
        id: "Operation.securityBreach.title",
        defaultMessage: "Security breach",
        description: "Security breach title",
    },
});
